"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountInfoRequest = void 0;
var AccountInfoRequest = /** @class */ (function () {
    function AccountInfoRequest() {
    }
    return AccountInfoRequest;
}());
exports.AccountInfoRequest = AccountInfoRequest;
;
//# sourceMappingURL=accountInfo.request.js.map